import { usePermissions } from '@/hooks/usePermissions'
import { useRouter } from 'next/router'

import { Box } from '@chakra-ui/react'

import { Button, TABLE_MAX_WIDTH, TableToolbar } from '@hivewatch/dark'
import type { ColorScheme } from '@hivewatch/dark'

import { CREATE_INCIDENT_RESPONSE_WORKFLOW } from '@/utils/routes'

interface WorkflowsTableToolbarIProps {
  colorScheme: ColorScheme
  filter: string
  setFilter: (value: string) => void
}

export const WorkflowsTableToolbar = ({
  colorScheme,
  filter,
  setFilter,
}: WorkflowsTableToolbarIProps) => {
  const router = useRouter()
  const { shouldShowCreateWorkflow } = usePermissions()

  return (
    <TableToolbar
      actions={
        <Box alignItems='center' display='flex' gap='8px'>
          {shouldShowCreateWorkflow && (
            <Button
              colorScheme={colorScheme}
              onClick={() => router.push(CREATE_INCIDENT_RESPONSE_WORKFLOW)}
              size='md'
              variant='primary'
            >
              Create a workflow
            </Button>
          )}
        </Box>
      }
      colorScheme={colorScheme}
      maxWidth={TABLE_MAX_WIDTH}
      onChange={setFilter}
      placeholder='Search workflows'
      value={filter ?? ''}
    />
  )
}
